import { acquireEndpoint } from "utils/SmartMerchandiserAPI";
import { takeEvery, call, put, select } from "typed-redux-saga/macro";
import { callApi } from "utils/SagaUtils";
import { postData } from "services/ApiService";
import { selectCurrentStoreId } from "store/store-list/StoreListSelectors";
import { SUBMIT_SEARCH_REINDEX } from "./SearchReindexTypes";

function* submitSearchReindex() {
  try {
    const actionType = SUBMIT_SEARCH_REINDEX;
    const constName = Object.keys({ SUBMIT_SEARCH_REINDEX })[0].toString();
    const storeId = yield* select(selectCurrentStoreId);
    const endpoint = acquireEndpoint(constName);
    const headers = {
      "x-store-id": storeId,
    };
    yield* call(callApi, actionType, postData, {}, endpoint, headers);
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: SUBMIT_SEARCH_REINDEX.FAILURE,
      message: e.message,
    });
  }
}

export function* watchSubmitSearchReindex() {
  yield* takeEvery(SUBMIT_SEARCH_REINDEX.REQUEST, submitSearchReindex);
}
